export enum ModalType {
  New = 'NEW_USER',
  View = 'UPDATE_USER',
}
